import { getTravelMap, TRAVEL_TYPES } from '../../../utils/animationsUtils';
const name = 'BgReveal';
const properties = {
    hideOnStart: false,
    requestFullScreenHeight: true,
    getMediaDimensions(width, height, screenHeight) {
        return { width, height: Math.max(height, screenHeight) };
    },
    groups: ['animation', 'background'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        speedFactor: {
            type: 'number',
            default: 1,
        },
        viewPortHeight: {
            type: 'number',
            min: 0,
        },
        componentHeight: {
            type: 'number',
            min: 0,
        },
    },
};
function animate(kit, elements, duration, delay, { componentHeight, componentTop, siteHeight, viewPortHeight, speedFactor = properties.schema.speedFactor.default, // TODO: when bgScrub is removed, we can remove this, factor becomes a constant 1
...params } = {}) {
    const sequence = kit.sequence(params);
    const { TOP_TO_BOTTOM, BOTTOM_TO_TOP } = getTravelMap(componentHeight, componentTop, siteHeight, viewPortHeight, TRAVEL_TYPES.normal);
    sequence.add(kit.animate('BaseBgParallaxY', elements, duration, delay, {
        viewPortHeight,
        componentHeight,
        speedFactor,
        start: TOP_TO_BOTTOM,
        end: BOTTOM_TO_TOP,
        ease: 'none',
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=bgReveal.js.map